export default __webpack_public_path__ + "locales/ro/ChangePortalOwner.json?hash=69b8b1f9ddb662c9dff94650938b0018";